import axios from "axios";

const ajax = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

const handleConfig = (config) => {
  const token = sessionStorage.getItem("token");
  config.headers.Authorization = "Bearer " + token;
  return {
    withCredentials: true,
    ...config,
  };
};

const handleError = (error) => {
  return Promise.reject(error);
};

ajax.interceptors.request.use(handleConfig, handleError);
axios.defaults.withCredentials = true;

export default ajax;
